module.exports = __webpack_public_path__ + "static/media/ic_underline.cfaaff4d.svg";